'use client'
import useMount from "react-use/lib/useMount";
import ContactForm from "./ContactForm";
import { useState } from "react";
import logPageView from "lib/ga/pageView";
import LazyImage from "components/LazyImage";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import styles from './contactUs.module.css'
import wrappers from 'components/_styled/wrappers.module.css';

const ContactUsWithReducer = () => {
  let [faq1, setFaq1] = useState(true);
  let [faq2, setFaq2] = useState(false);
  useMount(() => {
    logPageView({ url: window.location.pathname + window.location.search });
  });

  return (
    <div className={wrappers.FluidWrapper}>
      <div className={styles.contactWrapper}>
        <h1>Contact us</h1>

        <div className={styles.body}>
          <div className={styles.map}>
            <a
              href="https://maps.app.goo.gl/osE6TdMxoRABZvbi9"
              target="_blank"
              rel="noopener noreferrer"
              title="View our location on Google Maps"
              style={{ position: 'relative', minHeight: "290px" }}
              className={styles.mapImage}
            >
              <LazyImage
                src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}contact/map_200.png`}
                sources={[
                  {
                    srcSet: `${process.env.NEXT_PUBLIC_APP_CDN_URL}contact/map_200.webp 400w, ${process.env.NEXT_PUBLIC_APP_CDN_URL}contact/map_400.webp 600w`,
                    type: "image/webp",
                  },
                  {
                    srcSet: `${process.env.NEXT_PUBLIC_APP_CDN_URL}contact/map_200.png 400w, ${process.env.NEXT_PUBLIC_APP_CDN_URL}contact/map_400.png 600w`,
                    type: "image/jpg",
                  },
                ]}
                alt="View our location on Google Maps"
                layout="fill"
                // objectFit="contain"
                priority="true"
              />

            </a>
            <div className={styles.address}><LocationOnIcon /> Completely Retail, 51-53 High Street, Guildford, Surrey, GU1 3DY</div>
          </div>
          <ContactForm />
        </div>

        <div className={styles.faqs}>
          <h3>FAQ'S</h3>
          <div className={styles.underline}>
            <p className={faq1 ? `${styles.bold} ${styles.up}` : styles.bold} onClick={e => setFaq1(!faq1)}>What does Completely Retail do?</p>
            {faq1 && (
              <p >Completely Retail is the UK's only property marketing platform dedicated to connecting people actively seeking retail and leisure space with agents and landlords. We have the largest selection of available retail and leisure space in the UK and a range of tools to make it easy for occupiers to find the perfect space. If you're looking for retail property, Completely Retail is the place to start your search.</p>
            )}
          </div>

          <div className={styles.underline}>
            <p className={faq2 ? `${styles.bold} ${styles.up}` : styles.bold} onClick={e => setFaq2(!faq2)}>What is a Local Expert?</p>
            {
              faq2 && (
                <p>Every agent who lists with us is eligible to become a Local Expert. This comes into action if we're unable to find contacts for a particular property listing by providing options to connect searchers with local agents who work with similar property in the nearby area. If you have any questions about Local Experts, please <a href="#top">contact us</a>.</p>
              )
            }
          </div>

        </div>

      </div>

    </div>
  );
};

const ContactUs = (props) => {
  return (
    <ContactUsWithReducer {...props} />
  );
};

export default ContactUs;
